// ajax
$(document).ready(function () {
  const btns = $(".btn.load-more");
  if (btns && typeof btns != "undefined") {
    $(btns).click(ajax_query);
  }

  const category_btns = $(".category-filter-btn");
  if (category_btns && typeof category_btns != "undefined") {
    $(category_btns).click(ajax_query);
  }

  function ajax_query(e) {
    const btn = this;
    const posts_container = $(".posts-container");

    $.ajax({
      url: ajax_object.ajax_url,
      dataType: "json",
      type: "POST",
      data: {
        action: "load_more_function",

        page: +$(btn).attr("data-query-page") + 1,
        maxPage: +$(btn).attr("data-query-max-page"),
        postType: $(btn).attr("data-query-post-type"),
        postsPerPage: +$(btn).attr("data-query-posts-per-page"),

        categoryID: +$(btn).attr("data-query-category-id"),
        termID: +$(btn).attr("data-query-term-id"),
      },

      beforeSend: function () {
        console.log("loading...");

        if ($(btn).hasClass("category-filter-btn")) {
          const loadMoreBtn = $(".btn.load-more");
          $(loadMoreBtn).attr("data-query-page", 1);
          $(loadMoreBtn).attr(
            "data-query-max-page",
            $(btn).attr("data-query-max-page")
          );

          if ($(btn).hasClass("category-filter-all-btn")) {
            loadMoreBtn.removeAttr("data-query-category-id");
            loadMoreBtn.removeAttr("data-query-term-id");
          } else {
            loadMoreBtn.attr(
              "data-query-category-id",
              $(btn).attr("data-query-category-id")
            );
            loadMoreBtn.attr(
              "data-query-term-id",
              $(btn).attr("data-query-term-id")
            );
          }
        }
      },

      success: function (res) {
        if ($(btn).hasClass("category-filter-btn")) {
          $(posts_container).empty();
          $(btn).attr("data-query-max-page", res.data["max_num_pages"]);
          $(".btn.load-more").attr(
            "data-query-max-page",
            res.data["max_num_pages"]
          );
          $(".btn.load-more").removeClass("hidden");

          $(".category-filter-btn").removeClass("active");
          $(btn).addClass("active");
        }
        posts_container.append(res.data["posts"]);
        $(btn).attr("data-query-page", +$(btn).attr("data-query-page") + 1);

        if (
          +$(".btn.load-more").attr("data-query-page") >=
          +$(".btn.load-more").attr("data-query-max-page")
        ) {
          $(".btn.load-more").addClass("hidden");
        }
      },

      complete: function () {
        console.log("loaded");
      },
    });

    // cases image sizes
    // calculate_cases_image_size();
  }
});